import { track, disableTracking } from '../../vendor/splitmetrics-track';


/* Track events by clicking to application on Search and Top List Pages */

export const EVENT_NAME = 'app_view';


export default (eventProps = null, done = () => {}) => {
  track(EVENT_NAME, eventProps, { once: true, important: true, force: true }, done);
  disableTracking();
};



// WEBPACK FOOTER //
// ./src/lib/track-event/app-view.js